module.exports = __webpack_public_path__ + "img/tool3.859f17b5.png";